import { FormFieldError } from './FormFieldError';
import styles from './FormFieldTemp.module.css';

const renderTextInput = (props) => {
    const {
        input,
        placeholder,
        type,
        disabled,
        readOnly,
        label,
        hideError,
        meta: { touched, error },
        inputMode = 'text'
    } = props;

    return (
        <>
            {label && (
                <label className={styles.label} htmlFor={input.name}>
                    {label}
                </label>
            )}
            <input
                {...input}
                id={input.name}
                className={styles.input}
                placeholder={placeholder}
                data-testid={props['data-testid']}
                type={type}
                disabled={disabled}
                readOnly={!!readOnly}
                inputMode={inputMode}
            />
            {touched && <FormFieldError hide={hideError} message={error} />}
        </>
    );
};

export const renderField = (props) => renderTextInput(props);
